import { render } from "./query-index.vue?vue&type=template&id=c346adfa"
import script from "./query-index.vue?vue&type=script&lang=js"
export * from "./query-index.vue?vue&type=script&lang=js"

import "./query-index.vue?vue&type=style&index=0&id=c346adfa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__